import { combineReducers } from 'redux';
import { appReducer } from './reducer';

const reducerManager = {
   reducersMap: {
      appData: appReducer,
   },
   combinedReducers: null,
   updatedKeys: [],
};
reducerManager.combinedReducers = combineReducers(reducerManager.reducersMap);

const postModifyReducer = (key) => {
   reducerManager.combinedReducers = combineReducers(
      reducerManager.reducersMap
   );
   reducerManager.updatedKeys.push(key);
};

const replaceReducer = (key, reducer) => {
   reducerManager.reducersMap = {
      ...reducerManager.reducersMap,
      [key]: reducer,
   };
   postModifyReducer(key);
};

const removeReducer = (key) => {
   delete reducerManager.reducersMap[key];
   postModifyReducer(key);
};

const reduce = (state, action) => {
   if (reducerManager.updatedKeys.length > 0) {
      const newState = { ...state };
      reducerManager.updatedKeys.forEach((key) => {
         delete newState[key];
      });
      reducerManager.updatedKeys = [];
      return reducerManager.combinedReducers(newState, action);
   }
   return reducerManager.combinedReducers(state, action);
};

export { reduce, replaceReducer, removeReducer };
